import { render } from "./Preview.vue?vue&type=template&id=5740e73b&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=ts"
export * from "./Preview.vue?vue&type=script&lang=ts"

import "./Preview.vue?vue&type=style&index=0&id=5740e73b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5740e73b"

export default script